export interface FeatureFlags {
  kycVerification: boolean
  senderApproval: boolean
  urlMappedTemplates: boolean
  regulatoryOperatorKey: string
}

const configs: Record<string, FeatureFlags> = {
  IN: {
    kycVerification: false,
    senderApproval: false,
    urlMappedTemplates: true,
    regulatoryOperatorKey: 'ceind',
  },
  LA: {
    kycVerification: true,
    senderApproval: true,
    urlMappedTemplates: false,
    regulatoryOperatorKey: 'celao',
  },
}

const country = (process.env.REACT_APP_COUNTRY || 'IN').toUpperCase()
export const featureFlags: FeatureFlags = configs[country] ?? configs['IN']
export const currentCountry: string = country
export const REGULATORY_OPERATOR_KEY: string = featureFlags.regulatoryOperatorKey
